/*
 * Resilient variant rendering for the legacy Shrine/Dawn VariantSelects class.
 * The original method has no HTTP/error handling: one failed request leaves the
 * purchase button disabled and can let an older response overwrite a newer
 * selection. This patch keeps the existing component and markup, while making
 * its asynchronous boundary ordered and recoverable.
 */
(function () {
  if (typeof VariantSelects === 'undefined') return;

  /* Les listes déroulantes du thème indiquaient une option indisponible dans
     son libellé tout en la laissant sélectionnable. Conserver l'indication et
     exposer aussi l'état natif disabled évite un ajout 422 silencieux. */
  VariantSelects.prototype.setInputAvailability = function (inputs, availableValues) {
    inputs.forEach(function (input) {
      var available = availableValues.includes(input.getAttribute('value'));
      input.toggleAttribute('disabled', !available);
      input.textContent = available
        ? input.getAttribute('value')
        : window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
    });
  };

  VariantSelects.prototype.renderProductInfo = function () {
    /* Les upsells du panier disposent de leur propre synchronisation inline :
       ils n'ont pas de section produit Shopify à rerendre. Les envoyer dans le
       pipeline PDP provoquerait une redirection vers la fiche produit à chaque
       changement d'option. */
    if (this.id && this.id.indexOf('variant-selects-cart-upsell-') === 0) return;

    if (!this.currentVariant?.id) {
      this.toggleAddButton(true, window.variantStrings?.unavailable || window.variantStrings?.soldOut);
      return;
    }

    var variantId = this.currentVariant.id;
    var targetSection = this.dataset.section;
    var sourceSection = this.dataset.originalSection || targetSection;

    if (this.variantRequestController) this.variantRequestController.abort();
    this.variantRequestController = new AbortController();
    var signal = this.variantRequestController.signal;

    fetch(`${this.dataset.url}?variant=${variantId}&section_id=${sourceSection}`, { signal: signal })
      .then(function (response) {
        if (!response.ok) throw new Error(`Variant request failed (${response.status})`);
        return response.text();
      })
      .then((responseText) => {
        if (signal.aborted || !this.isConnected || this.currentVariant?.id !== variantId) return;

        var sourceDocument = new DOMParser().parseFromString(responseText, 'text/html');
        if (
          !sourceDocument.getElementById(`price-${sourceSection}`) &&
          !sourceDocument.getElementById(`ProductSubmitButton-${sourceSection}`)
        ) {
          throw new Error('Variant response is missing product content');
        }

        function copyContent(stem) {
          var target = document.getElementById(`${stem}-${targetSection}`);
          var source = sourceDocument.getElementById(`${stem}-${sourceSection}`);
          if (target && source) target.innerHTML = source.innerHTML;
          return { target: target, source: source };
        }

        var price = copyContent('price');
        copyContent('atc-price');
        copyContent('option-1-price');
        copyContent('option-2-price');
        copyContent('option-3-price');
        copyContent('option-4-price');
        copyContent('option-1-variant');
        copyContent('option-2-variant');
        copyContent('option-3-variant');
        copyContent('option-4-variant');
        var sku = copyContent('Sku');
        var inventory = copyContent('Inventory');

        price.target?.classList.remove('visibility-hidden');
        if (sku.target && sku.source) {
          sku.target.classList.toggle(
            'visibility-hidden',
            sku.source.classList.contains('visibility-hidden')
          );
        }
        if (inventory.target && inventory.source) {
          inventory.target.classList.toggle(
            'visibility-hidden',
            inventory.source.innerText.trim() === ''
          );
        }

        var sourceButton = sourceDocument.getElementById(`ProductSubmitButton-${sourceSection}`);
        this.toggleAddButton(
          !sourceButton || sourceButton.hasAttribute('disabled'),
          window.variantStrings.soldOut
        );

        var stickyButton = this.closest('section')?.querySelector(
          '.sticky-atc button[name="add"]'
        );
        var stickySource = sourceDocument.querySelector('.sticky-atc button[name="add"]');
        if (stickyButton && stickySource) {
          stickyButton.innerHTML = stickySource.innerHTML;
          stickyButton.toggleAttribute('disabled', stickySource.hasAttribute('disabled'));
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: sourceSection,
            html: sourceDocument,
            variant: this.currentVariant
          }
        });
      })
      .catch((error) => {
        if (signal.aborted || error?.name === 'AbortError') return;
        if (!this.isConnected || this.currentVariant?.id !== variantId) return;

        console.error(error);
        var productForm = this.closest('section')?.querySelector('product-form');
        productForm?.handleErrorMessage(window.cartStrings?.error || 'Unable to load this option.');

        /* A full Shopify-rendered product page is the safest fallback: it
           restores price, availability and selected variant atomically. */
        var separator = this.dataset.url.includes('?') ? '&' : '?';
        window.location.assign(`${this.dataset.url}${separator}variant=${variantId}`);
      });
  };
})();
